import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=a21696de&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a21696de')) {
      api.createRecord('a21696de', component.options)
    } else {
      api.reload('a21696de', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=a21696de&", function () {
      api.rerender('a21696de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25ItO00WqRiv2/JS/offershelp.vue"
export default component.exports